import nai_grupas from "./naigrupas.js";
import plavas from "./plavas.js";

function ids_from_to(start, end) {
  let ids = [];
  for (let i = start; i <= end; i++) {
    ids.push(String(i));
  }
  return ids;
}
function link(name, url) {
  return `<a href='${url}' rel='noopener noreferrer' target='_blank'>${name}</a>`;
}
function date(days) {
  let today = new Date();
  let other_day = new Date();
  other_day.setDate(today.getDate() + days);
  return other_day.toISOString().slice(0, 10);
}

const layers = {
  "05_plavas": {
    info: "https://dabiskoplavuprodukts.lv/",
    legend: "legend_plavas.png",
    legend_width: 229,
    parts: {
      0: {
        options: {
          pointToLayer: function (point, latlng) {
            return L.marker(latlng, {
              icon: L.icon({
                iconUrl: "./plava-icon2.png",
                iconSize: [30, 30],
              }),
            });
          },
        },
        popup: function (l) {
          const p = l.feature.properties;
          // Support both property formats
          const name = p.name || p.Nosaukum_1 || "";
          const address = p.address || p.Adrese_1 || "";
          const id = p.id || "";
          const saite = p.Saite || "";
          // Prefer id for link, fallback to Saite
          const linkUrl = id
            ? `https://dabiskoplavuprodukts.lv/razotaji/${id}`
            : saite;
          return `<b>${name}</b><br>${address}<br><a href="${linkUrl}" rel='noopener noreferrer' target='_blank'>Vairāk info</a>`;
        },
        type: "geojson",
        features: plavas,
      },
      // 1: {
      //   options: {
      //     pointToLayer: function (point, latlng) {
      //       return L.marker(latlng, {
      //         icon: L.icon({
      //           iconUrl: "./plava-icon2.png",
      //           iconSize: [30, 30],
      //         }),
      //       });
      //     },
      //   },
      //   popup: function (l) {
      //     const p = l.feature.properties;
      //     const name = p.name || p.Nosaukum_1 || "";
      //     const address = p.address || p.Adrese_1 || "";
      //     const id = p.id || "";
      //     const saite = p.Saite || "";
      //     const linkUrl = id
      //       ? `https://dabiskoplavuprodukts.lv/razotaji/${id}`
      //       : saite;
      //     return `<b>${name}</b><br>${address}<br><a href="${linkUrl}" rel='noopener noreferrer' target='_blank'>Vairāk info</a>`;
      //   },
      //   type: "geojson",
      //   features: plavas_jaunakie,
      // },
    },
    visible_default: false,
  },
  // is.mantojums.lv is offline; moved to the NKMP geoserver used by the forest app.
  // The old Latvian sublayer names do not exist there - these are the equivalents.
  "10_kult": {
    attribution: `&copy; ${link(
      "Nacionālā kultūras mantojuma pārvalde",
      "https://mantojums.lv/"
    )}`,
    info: "https://geolatvija.lv/geo/p/613",
    legend: "legend_kulturas_pieminekli.png",
    legend_width: 260,
    parts: {
      0: {
        options: {
          format: "image/png",
          identify: false,
          transparent: true,
        },
        sublayers: [
          "monument:monuments_view_culturalobject_public",
          "monument:monuments_protectionzone_public",
          "monument:monuments_rvceka",
          "monument:monuments_culturalobject_unesco",
        ],
        type: "wms",
        url: "https://geoserver.mantojums.lv/geoserver/monument/wms",
      },
    },
    visible_default: false,
  },
  // ZMNI - Original service currently unavailable (server down)
  // "15_zmni": {
  //   info: "https://geolatvija.lv/geo/p/241",
  //   parts: {
  //     0: {
  //       options: {
  //         format: "image/png",
  //         identify: false,
  //         transparent: true,
  //       },
  //       sublayers: ids_from_to(0, 18),
  //       type: "wms",
  //       url: "https://dpps.viss.gov.lv/DPPS.REQ/URN_IVIS_100001_ISS-ZM.ZMNI-ZMNI_WMS_26012021-v1-0/guest/URN_IVIS_100273_LIC-A84438D2398F2A4B8D2A0F9F817DFA5C",
  //     },
  //   },
  //   visible_default: false,
  // },
  // lvmgeoserver.lvm.lv is offline; moved to the ZMNI melioration cadastre
  // published as an INSPIRE service via ĢeoLatvija (geoproduct 156).
  // Sublayer names differ from the old service - they are snake_case here, and
  // zmni_watercourses / zmni_zmniregion / zmni_waterdrainditches /
  // zmni_connectionpoints / zmni_hydropost no longer exist. One unknown name
  // fails the whole GetMap, so this list must stay in sync with the service.
  // zmni_catchment is deliberately omitted: it renders an opaque fill that
  // hides the basemap. The INSPIRE_HY_ZMNI group layer is opaque for the same
  // reason and must not be used.
  "15_melioracijas": {
    attribution: `&copy; ${link(
      "ZMNĪ",
      "https://www.zmni.lv/melioracijas-kadastrs/"
    )}`,
    info: "https://geolatvija.lv/main?geoProductId=156",
    // The service styles every line the same blue, every point the same red and
    // every polygon grey, so the legend groups by geometry rather than listing
    // all 18 sublayers - it cannot distinguish e.g. grāvji from drenas.
    legend: "legend_melioracija.png",
    legend_width: 290,
    parts: {
      0: {
        options: {
          crossOrigin: "anonymous",
          format: "image/png",
          identify: false,
          transparent: true,
        },
        sublayers: [
          "zmni_polder_territory",
          "zmni_state_controlled_rivers",
          "zmni_drain_system",
          "zmni_drainpipes",
          "zmni_drain_collectors",
          "zmni_big_drain_collectors",
          "zmni_ditches",
          "zmni_network_structures",
          "zmni_state_rivers_polygon",
          "zmni_state_rivers_line",
          "zmni_dam",
          "zmni_ditch_picket",
          "zmni_state_river_pickets",
          "zmni_dam_picket",
          "zmni_polder_pumping_station",
          "zmni_transport_structures",
          "zmni_help_objects",
          "zmni_decommissioned_systems"
        ],
        type: "wms",
        url: "https://geo-dpps.viss.gov.lv/api/DPPSPackage/client/Latvijas_m_258_Hc1unC/7763a643-7e70-41a7-af9a-0f0e90841af8",
      },
    },
    visible_default: false,
  },
  "16_ozols": {
    info: "https://www.daba.gov.lv/lv/dabas-datu-sistema-ozols",
    legend: "legend_ozols.png",
    legend_width: 275,
    parts: {
      0: {
        options: {
          format: "image/png",
          identify: false,
          transparent: true,
        },
        type: "xyz",
        url: "https://api.mapbox.com/styles/v1/recon517/ck0yrgg0l0o2s1dnwgm3dc3ng/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoicmVjb241MTciLCJhIjoiY2l4cXBpbzZtMDAzNDMybDY2YnAzdjlndSJ9.MRq_ohDyD2x5t5DdlAwytA",
      },
      1: {
        options: {
          format: "image/png",
          identify: false,
          transparent: true,
        },
        type: "wms",
        sublayers: ids_from_to(0, 4),
        url: "https://ozols.gov.lv/arcgis/services/OZOLS_DABASDATI_PUB_INSPIRE/MapServer/WMSServer",
      },
    },
    visible_default: false,
  },

  // new layer

//   "20_nai_grupas": {
//   parts: {
//     0: {
//       options: {
//         pointToLayer: function (feature, latlng) {
//           const grupaColors = {
//             A: "#17345C",
//             B: "#3F81B2",
//             C: "#81B5D3",
//             D: "#C5DAEA",
//           };
//           const grupaRadii = {
//             A: 10,
//             B: 8,
//             C: 6,
//             D: 4,
//           };
//           const grupa = feature.properties.Grupa;
//           return L.circleMarker(latlng, {
//             radius: grupaRadii[grupa] || 6,
//             fillColor: grupaColors[grupa] || "#aaa",
//             color: "#333",
//             weight: 1,
//             opacity: 1,
//             fillOpacity: 0.8,
//           });
//         }
//       },
//       type: "geojson",
//       features: nai_grupas,
//       popup: function (l) {
//         const p = l.feature.properties;
//         return `
//           <b>${p.Nosaukums}</b><br>
//           <b>Dūņu daudzums:</b> ${p.Dunas}<br>
//           <b>Grupa:</b> ${p.Grupa}
//         `;
//       },
//     },
//   },
//   visible_default: true,
// },

  ///////////////////////////////

  "171_dunu_komposts_2025": {
    attribution: `&copy; ${link("LAD", "https://www.lad.gov.lv/lv")}`,
    // info: 'https://www.lad.gov.lv/lv/katalogs/klimatiskas-un-vidiskas-shemas-ekoshemas-2024g',
    legend: 'legend-notekudeni.png',
    legend_width: 250,
    project: "np.png",
    project_width: 200,
    parts: {
      0: {
        options: {
          edgeBufferTiles: 1,
          tms: false,
          opacity: 0.7,
          maxZoom: 18,
        },
        type: "xyz",
        url: "https://api.forestradar.com/xyz/v1/fr/org/zs-dunu-komposts/{z}/{x}/{y}.png?time=2025",
      },
      1: {
        options: {
          pointToLayer: function (feature, latlng) {
            const grupaColors = {
              A: "#17345C",
              B: "#3F81B2",
              C: "#81B5D3",
              D: "#C5DAEA",
            };
            const grupaRadii = {
              A: 10,
              B: 8,
              C: 6,
              D: 4,
            };
            const grupa = feature.properties.Grupa;
            return L.circleMarker(latlng, {
              radius: grupaRadii[grupa] || 6,
              fillColor: grupaColors[grupa] || "#aaa",
              color: "#333",
              weight: 1,
              opacity: 1,
              fillOpacity: 0.8,
            });
          },
          onEachFeature: function (feature, layer) {
            const label = 
              `<b>${feature.properties.Nosaukums || ""}</b><br>Dūņas: ${feature.properties.Dunas}`;
            layer.bindTooltip(label, {
              permanent: true,
              direction: "top",
              offset: L.point(18, -18),
              className: "custom-nai-label"
            });

            layer.closeTooltip();

            layer.on("add", function() {
              const map = layer._map;
              if (!map) return;
              function toggleTooltip() {
                if (map.getZoom() >= 12) {
                  layer.openTooltip();
                } else {
                  layer.closeTooltip();
                }
              }
              toggleTooltip();
              map.on("zoomend", toggleTooltip);

              layer.on("remove", function() {
                map.off("zoomend", toggleTooltip);
              });
            });
          }
        },
        type: "geojson",
        features: nai_grupas,
        popup: function (l) {
          const p = l.feature.properties;
          return `
            <b>${p.Nosaukums || "Nav nosaukuma"}</b><br>
            <b>Dūņu daudzums:</b> ${p.Dunas || "N/A"}<br>
            <b>Grupa:</b> ${p.Grupa || "N/A"}
          `;
        },
      },
    },
    visible_default: false,
  },
  
  "172_dunu_komposts_2024": {
    attribution: `&copy; ${link("LAD", "https://www.lad.gov.lv/lv")}`,
    // info: 'https://www.lad.gov.lv/lv/katalogs/klimatiskas-un-vidiskas-shemas-ekoshemas-2024g',
    legend: 'legend-notekudeni.png',
    legend_width: 250,
    project: "np.png",
    project_width: 200,
    parts: {
      0: {
        options: {
          edgeBufferTiles: 1,
          tms: false,
          opacity: 0.7,
          maxZoom: 18,
        },
        type: "xyz",
        url: "https://api.forestradar.com/xyz/v1/fr/org/zs-dunu-komposts/{z}/{x}/{y}.png?time=2024",
      },
      1: {
        options: {
          pointToLayer: function (feature, latlng) {
            const grupaColors = {
              A: "#17345C",
              B: "#3F81B2",
              C: "#81B5D3",
              D: "#C5DAEA",
            };
            const grupaRadii = {
              A: 10,
              B: 8,
              C: 6,
              D: 4,
            };
            const grupa = feature.properties.Grupa;
            return L.circleMarker(latlng, {
              radius: grupaRadii[grupa] || 6,
              fillColor: grupaColors[grupa] || "#aaa",
              color: "#333",
              weight: 1,
              opacity: 1,
              fillOpacity: 0.8,
            });
          },
          onEachFeature: function (feature, layer) {
            const label = 
              `<b>${feature.properties.Nosaukums || ""}</b><br>Dūņas: ${feature.properties.Dunas}`;
            layer.bindTooltip(label, {
              permanent: true,
              direction: "top",
              offset: L.point(18, -18),
              className: "custom-nai-label"
            });

            layer.closeTooltip();

            layer.on("add", function() {
              const map = layer._map;
              if (!map) return;
              function toggleTooltip() {
                if (map.getZoom() >= 12) {
                  layer.openTooltip();
                } else {
                  layer.closeTooltip();
                }
              }
              toggleTooltip();
              map.on("zoomend", toggleTooltip);

              layer.on("remove", function() {
                map.off("zoomend", toggleTooltip);
              });
            });
          }
        },
        type: "geojson",
        features: nai_grupas,
        popup: function (l) {
          const p = l.feature.properties;
          return `
            <b>${p.Nosaukums || "Nav nosaukuma"}</b><br>
            <b>Dūņu daudzums:</b> ${p.Dunas || "N/A"}<br>
            <b>Grupa:</b> ${p.Grupa || "N/A"}
          `;
        },
      },
    },
    visible_default: false,
  },
  
  "18_eko4_2024": {
    attribution: `&copy; ${link("LAD", "https://www.lad.gov.lv/lv")}`,
    info: "https://www.lad.gov.lv/lv/katalogs/klimatiskas-un-vidiskas-shemas-ekoshemas-2024g#4-ekoshemas-atbalsts-par-saudzejosu-lauksaimniecibas-praksi-eko4",
    legend: "eko4-legend.png",
    legend_width: 260,
    project: "novasoil-logo.svg",
    project_width: 200,
    parts: {
      0: {
        options: {
          edgeBufferTiles: 1,
          tms: false,
          opacity: 0.7,
        },
        type: "xyz",
        url: "https://api.forestradar.com/xyz/v1/fr/org/zs-eko4/{z}/{x}/{y}.png?time=2024",
      },
    },
    visible_default: false,
  },
  "19_eko4_2023": {
    attribution: `&copy; ${link("LAD", "https://www.lad.gov.lv/lv")}`,
    info: "https://www.lad.gov.lv/lv/katalogs/klimatiskas-un-vidiskas-shemas-ekoshemas-2024g#4-ekoshemas-atbalsts-par-saudzejosu-lauksaimniecibas-praksi-eko4",
    legend: "eko4-legend.png",
    legend_width: 260,
    project: "novasoil-logo.svg",
    project_width: 200,
    parts: {
      0: {
        options: {
          edgeBufferTiles: 1,
          tms: false,
          opacity: 0.7,
        },
        type: "xyz",
        url: "https://api.forestradar.com/xyz/v1/fr/org/zs-eko4/{z}/{x}/{y}.png?time=2023",
      },
    },
    visible_default: false,
  },

  "21_lad_bloki": {
    info: "https://geolatvija.lv/geo/p/663",
    legend: "legend_lad_bloki.png",
    legend_width: 106,
    parts: {
      0: {
        options: {
          format: "image/png",
          identify: false,
          transparent: true,
          dpi: "140",
        },
        sublayers: ["0"],
        type: "wms",
        url: "https://karte.lad.gov.lv/arcgis/services/lauku_bloki/MapServer/WMSServer",
      },
    },
    visible_default: false,
  },
  "22_lad_lauki": {
    info: "https://geolatvija.lv/geo/p/664",
    legend: "legend_lad_lauki.png",
    legend_width: 135,
    parts: {
      0: {
        options: {
          format: "image/png",
          identify: false,
          transparent: true,
          dpi: "120",
        },
        sublayers: ["0"],
        type: "wms",
        url: "https://karte.lad.gov.lv/arcgis/services/lauki/MapServer/WMSServer",
      },
    },
    visible_default: false,
  },
  // Legend colours taken from the Mapbox style JSON (zs-water-bodies).
  "24_water_bodies": {
    legend: "legend_udenstilpes.png",
    legend_width: 127,
    attribution: `&copy; ${link("LĢIA", "https://www.lgia.gov.lv")}`,
    info: "https://opendata.lgia.gov.lv/zf_wp/index.php/2018/08/03/topografiska-karte-meroga-150-000-2-izdevums/",
    parts: {
      0: {
        options: {
          format: "image/png",
          identify: false,
          transparent: true,
        },
        type: "xyz",
        url: "https://api.mapbox.com/styles/v1/recon517/ck0sz2nv11nu91cqp4w4mdxrk/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoicmVjb241MTciLCJhIjoiY2l4cXBpbzZtMDAzNDMybDY2YnAzdjlndSJ9.MRq_ohDyD2x5t5DdlAwytA",
      },
    },
    visible_default: false,
  },
  "25_soil_group": {
    attribution: `&copy; ${link("VAAD", "https://www.vaad.gov.lv/lv")}`,
    info: "https://geolatvija.lv/main?geoproduct=open&geoProductId=289",
    legend: "soil-group-legend.png",
    legend_width: 220,
    project: "interreg-logo.png",
    project_width: 400,
    parts: {
      0: {
        options: {
          edgeBufferTiles: 1,
          tms: false,
          opacity: 0.7,
        },
        type: "xyz",
        url: "https://api.forestradar.com/xyz/v1/fr/org/soil-group/{z}/{x}/{y}.png",
      },
    },
    visible_default: true,
  },
  "26_soil_contents": {
    attribution: `&copy; ${link("VAAD", "https://www.vaad.gov.lv/lv")}`,
    info: "https://geolatvija.lv/main?geoproduct=open&geoProductId=289",
    legend: "soil-contents-legend.png",
    legend_width: 100,
    project: "interreg-logo.png",
    project_width: 400,
    parts: {
      0: {
        options: {
          edgeBufferTiles: 1,
          tms: false,
          opacity: 0.7,
        },
        type: "xyz",
        url: "https://api.forestradar.com/xyz/v1/fr/org/soil-contents/{z}/{x}/{y}.png",
      },
    },
    visible_default: false,
  },
  "27_soil_value": {
    attribution: `&copy; ${link(
      "Zemkopības ministrija",
      "https://www.zm.gov.lv/"
    )}`,
    info: "https://llufb.llu.lv/conference/lidzsvar_lauksaim/2016/Latvia-lidzsvarota-lauksaimnieciba2016-49-62.pdf#page=5",
    // The Mapbox style draws region borders plus text labels on the map, so the
    // legend only needs the border symbol - the regions label themselves.
    legend: "legend_augsnes_vertiba.png",
    legend_width: 230,
    parts: {
      0: {
        options: {
          format: "image/png",
          identify: false,
          transparent: true,
        },
        type: "xyz",
        url: "https://api.mapbox.com/styles/v1/recon517/ck0v9ehr90phy1cqzu3hzkmmc/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoicmVjb241MTciLCJhIjoiY2l4cXBpbzZtMDAzNDMybDY2YnAzdjlndSJ9.MRq_ohDyD2x5t5DdlAwytA",
      },
      1: {
        options: {
          format: "image/png",
          identify: false,
          transparent: true,
        },
        type: "xyz",
        url: "https://api.mapbox.com/styles/v1/recon517/ck0vs82zx2pw51cmz4yjh73kn/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoicmVjb241MTciLCJhIjoiY2l4cXBpbzZtMDAzNDMybDY2YnAzdjlndSJ9.MRq_ohDyD2x5t5DdlAwytA",
      },
    },
    visible_default: false,
  },
  // lvmgeoserver.lvm.lv is offline; served directly from Silava, who produced
  // the DTW data that LVM GEO was republishing.
  "28_dtw_malains": {
    attribution: `&copy; ${link(
      'LVMI "Silava"',
      "https://www.silava.lv/"
    )}`,
    info: "https://www.lbtu.lv/sites/default/files/files/projects/LIFE-OrgBalt-1st_Technical-article_final_canva_11.pdf",
    legend: "legend_depth_to_water.png",
    legend_width: 200,
    parts: {
      0: {
        options: {
          crossOrigin: "anonymous",
          format: "image/png",
          identify: false,
          transparent: true,
        },
        sublayers: ["DTW10"],
        type: "wms",
        url: "https://silava.forestradar.com/geoserver/silava/wms",
      },
    },
    visible_default: false,
  },
  "29_dtw_smilsains": {
    attribution: `&copy; ${link(
      'LVMI "Silava"',
      "https://www.silava.lv/"
    )}`,
    info: "https://www.lbtu.lv/sites/default/files/files/projects/LIFE-OrgBalt-1st_Technical-article_final_canva_11.pdf",
    legend: "legend_depth_to_water.png",
    legend_width: 200,
    parts: {
      0: {
        options: {
          crossOrigin: "anonymous",
          format: "image/png",
          identify: false,
          transparent: true,
        },
        sublayers: ["DTW30"],
        type: "wms",
        url: "https://silava.forestradar.com/geoserver/silava/wms",
      },
    },
    visible_default: false,
  },
  // Hidden: lvmgeoserver.lvm.lv (LVM GEO) is offline, so this layer cannot
  // load. Restore this block once LVM restores the service.
  // "30_dtw_lvm": {
  // attribution: `&copy; ${link("LVM GEO", "https://www.lvmgeo.lv/en/data")}`,
  // info: "https://www.lvmgeo.lv/en/data",
  // legend: "legend_depth_to_water.png",
  // legend_width: 200,
  // parts: {
  // 0: {
  // options: {
  // crossOrigin: "anonymous",
  // format: "image/png",
  // identify: false,
  // transparent: true,
  // },
  // sublayers: ["public:DTW_LVM"],
  // type: "wms",
  // url: "https://lvmgeoserver.lvm.lv/geoserver/ows",
  // },
  // },
  // visible_default: false,
  // },
  // LVM GEO moved off lvmgeoserver.lvm.lv to the geoserver.lvmgeo.lv proxy,
  // which is split into a raster and a vector endpoint - the cadastre map is on
  // the vector one. This style labels the parcel number on the map itself, so
  // no click lookup is needed (the proxy blocks GetFeatureInfo anyway).
  // Drawn below 1:50000, so it is legitimately empty when zoomed out.
  "31_cadastre": {
    attribution: `&copy; ${link(
      "LVM GEO",
      "https://www.lvmgeo.lv/dati"
    )} &copy; ${link(
      "VZD",
      "https://www.vzd.gov.lv/lv/kadastra-telpisko-datu-atversana"
    )}`,
    info: "https://www.lvmgeo.lv/dati",
    legend: "legend_kadastrs.png",
    legend_width: 130,
    parts: {
      0: {
        options: {
          crossOrigin: "anonymous",
          format: "image/png",
          identify: false,
          transparent: true,
        },
        sublayers: ["Kadastra_karte"],
        type: "wms",
        url: "https://geoserver.lvmgeo.lv/wmsvector62531a9bfcfa4015856924e94076a179",
      },
    },
    visible_default: false,
  },
  "89_s2_meta": {
    attribution: `&copy; ${link(
      "Baltic Satellite Service",
      "https://www.baltsat.lv/"
    )} &copy; ${link("ESA", "https://www.esa.int/")}`,
    info: "http://www.esa.int/Applications/Observing_the_Earth/Copernicus/Sentinel-2",
    parts: {
      0: {
        options: {
          edgeBufferTiles: 1,
          tms: false,
        },
        type: "time-xyz",
        url: "https://api.forestradar.com/xyz/v1/fr/org/s2-baltics/{z}/{x}/{y}.png?layer=meta&time={time}&key=zs-1SgDrryWPSQJQI0dAXBA8g",
      },
    },
    visible_default: false,
    default_time: "latest",
    default_layer: "meta",
  },
  "90_s2_rgb": {
    attribution: `&copy; ${link(
      "Baltic Satellite Service",
      "https://www.baltsat.lv/"
    )} &copy; ${link("ESA", "https://www.esa.int/")}`,
    info: "http://www.esa.int/Applications/Observing_the_Earth/Copernicus/Sentinel-2",
    parts: {
      0: {
        options: {
          edgeBufferTiles: 1,
          tms: false,
        },
        type: "time-xyz",
        url: "https://api.forestradar.com/xyz/v1/fr/org/s2-baltics/{z}/{x}/{y}.png?layer={layer}&time={time}&key=zs-1SgDrryWPSQJQI0dAXBA8g",
      },
    },
    visible_default: false,
    default_time: "latest",
    default_layer: "rgb",
  },

  // '91_s2_nirrg': {
  //   attribution: `&copy; ${link('Baltic Satellite Service', 'https://www.baltsat.lv/')} &copy; ${link('ESA', 'https://www.esa.int/')}`,
  //   info: 'http://www.esa.int/Applications/Observing_the_Earth/Copernicus/Sentinel-2',
  //   parts: {
  //     0: {
  //       options: {
  //         format: 'image/png',
  //         identify: false,
  //         transparent: true,
  //       },
  //       type: 'wms',
  //       sublayers: ['s2_metadata'],
  //       url: 'https://wms.forestradar.com/wms-v1/dmo-9EDp-Q7Nutoz_Mn4QOtv_A/wms'
  //     },
  //     1: {
  //       options: {
  //         edgeBufferTiles: 1,
  //         token: 'dmo-9EDp-Q7Nutoz_Mn4QOtv_A',
  //       },
  //       type: 'xyz',
  //       url: 'https://wms.forestradar.com/tiles-v1/{token}/s2-nir-r-g/{z}/{x}/{y}.png',
  //     },
  //   },
  //   visible_default: false,
  // },

  // '92_s2_ndvi': {
  //   attribution: `&copy; ${link('Baltic Satellite Service', 'https://www.baltsat.lv/')} &copy; ${link('ESA', 'https://www.esa.int/')}`,
  //   info: 'http://www.esa.int/Applications/Observing_the_Earth/Copernicus/Sentinel-2',
  //   legend: 'ndvi-legend.svg',
  //   parts: {
  //     // 0: {
  //     //   options: {
  //     //     format: 'image/png',
  //     //     identify: false,
  //     //     transparent: true,
  //     //   },
  //     //   type: 'wms',
  //     //   sublayers: ['s2_metadata'],
  //     //   url: 'https://wms.forestradar.com/wms-v1/dmo-9EDp-Q7Nutoz_Mn4QOtv_A/wms'
  //     // },
  //     1: {
  //       options: {
  //         edgeBufferTiles: 1,
  //         token: 'dmo-9EDp-Q7Nutoz_Mn4QOtv_A',
  //       },
  //       type: 'xyz',
  //       url: 'https://wms.forestradar.com/tiles-v1/{token}/s2-ndvi/{z}/{x}/{y}.png',
  //     },
  //   },
  //   visible_default: false,
  // },

  // '93_s2_msavi2': {
  //   attribution: `&copy; ${link('Baltic Satellite Service', 'https://www.baltsat.lv/')} &copy; ${link('ESA', 'https://www.esa.int/')}`,
  //   info: 'http://www.esa.int/Applications/Observing_the_Earth/Copernicus/Sentinel-2',
  //   legend: 'ndvi-legend.svg',
  //   parts: {
  //     0: {
  //       options: {
  //         format: 'image/png',
  //         identify: false,
  //         transparent: true,
  //       },
  //       type: 'wms',
  //       sublayers: ['s2_metadata'],
  //       url: 'https://wms.forestradar.com/wms-v1/dmo-9EDp-Q7Nutoz_Mn4QOtv_A/wms'
  //     },
  //     1: {
  //       options: {
  //         edgeBufferTiles: 1,
  //         token: 'dmo-9EDp-Q7Nutoz_Mn4QOtv_A',
  //       },
  //       type: 'xyz',
  //       url: 'https://wms.forestradar.com/tiles-v1/{token}/s2-msavi2/{z}/{x}/{y}.png',
  //     },
  //   },
  //   visible_default: false,
  // },

  // LVM GEO moved off lvmgeoserver.lvm.lv to the geoserver.lvmgeo.lv proxy;
  // the orthophoto is on its raster endpoint. 7th cycle (2019-2021) matches
  // the years quoted in the captions; an 8th cycle (2022) is also published.
  "95_ortho_rgb": {
    attribution: `&copy; ${link(
      "LVM GEO",
      "https://www.lvmgeo.lv/dati"
    )} &copy; ${link("LĢIA", "https://www.lgia.gov.lv/")}`,
    info: "https://www.lvmgeo.lv/dati",
    parts: {
      0: {
        options: {
          crossOrigin: "anonymous",
          format: "image/png",
          identify: false,
          transparent: true,
        },
        sublayers: ["Orto_7cikls"],
        type: "wms",
        url: "https://geoserver.lvmgeo.lv/wms62531a9bfcfa4015856924e94076a178",
      },
    },
    visible_default: false,
  },
  "96_ortho_ir": {
    attribution: `&copy; ${link(
      "LVM GEO",
      "https://www.lvmgeo.lv/dati"
    )} &copy; ${link("LĢIA", "https://www.lgia.gov.lv/")}`,
    info: "https://www.lvmgeo.lv/dati",
    parts: {
      0: {
        options: {
          crossOrigin: "anonymous",
          format: "image/png",
          identify: false,
          transparent: true,
        },
        sublayers: ["OrtoIR_7cikls"],
        type: "wms",
        url: "https://geoserver.lvmgeo.lv/wms62531a9bfcfa4015856924e94076a178",
      },
    },
    visible_default: false,
  },
  // lvmgeoserver.lvm.lv is offline; switched to the Baltics DTM used by the forest app.
  "98_dtm": {
    attribution: `&copy; ${link(
      "Forest Radar",
      "https://www.forestradar.com/"
    )}`,
    info: "https://www.forestradar.com/",
    legend: "legend_dtm.png",
    legend_width: 70,
    parts: {
      0: {
        options: {
          edgeBufferTiles: 1,
          tms: false,
          opacity: 1,
          maxNativeZoom: 14,
        },
        type: "xyz",
        url: "https://api.forestradar.com/xyz/v1/fr/org/baltics-dtm/{z}/{x}/{y}.png",
      },
    },
    visible_default: false,
  },
  // '95_ortho_rgb': {
  //   attribution: `&copy; ${link('Baltic Satellite Service', 'https://www.baltsat.lv/')} &copy; ${link('LĢIA', 'https://www.lgia.gov.lv/')}`,
  //   info: 'https://www.lgia.gov.lv/lv/node/335',
  //   parts: {
  //     0: {
  //       options: {
  //         edgeBufferTiles: 1,
  //         token: 'dmo-9EDp-Q7Nutoz_Mn4QOtv_A',
  //       },
  //       type: 'xyz',
  //       url: 'https://lv1.forestradar.com/tiles-v2/lgia-rgb/{z}/{x}/{y}.jpg?token={token}',
  //     }
  //   },
  //   visible_default: false,
  // },
  // '96_dtm': {
  //   attribution: `&copy; ${link('Baltic Satellite Service', 'https://www.baltsat.lv/')} &copy; ${link('LĢIA', 'https://www.lgia.gov.lv/')}`,
  //   info: 'https://www.lgia.gov.lv/lv/Digit%C4%81lais%20virsmas%20modelis',
  //   parts: {
  //     0: {
  //       options: {
  //         edgeBufferTiles: 1,
  //         token: 'dmo-9EDp-Q7Nutoz_Mn4QOtv_A',
  //       },
  //       type: 'xyz',
  //       url: 'https://lv2.forestradar.com/tiles-v2/lgia-dtm/{z}/{x}/{y}.jpg?token={token}'
  //     },
  //   },
  //   visible_default: false,
  // },

  // '40_tapis': {
  //   options: {
  //     format: 'image/png',
  //     identify: false,
  //     transparent: true,
  //   },
  //   type: 'wms',
  //   sublayers: ['reglamentetie', 'tematiskie', 'anotacijas', 'planojumu_teritorijas'],
  //   // sublayers: ['planojumu_teritorijas'],
  //   url: 'https://dpps.viss.gov.lv/DPPS.REQ/URN_IVIS_100001_ISS-VIDM-WMS_tapis_apvienotie-v1-0/guest/URN_IVIS_100273_LIC-45BA3DD7504DB84BB60C402D6A0BDDB2'
  // },

  "99_osm": {
    attribution: `&copy; ${link(
      "Mapbox",
      "https://www.mapbox.com/about/maps/"
    )} &copy; ${link(
      "OpenStreetMap",
      "https://www.openstreetmap.org/copyright"
    )} <strong>${link(
      "Improve this map",
      "https://www.mapbox.com/map-feedback/"
    )}</strong>`,
    info: "https://www.openstreetmap.org/",
    parts: {
      0: {
        options: {
          edgeBufferTiles: 1,
          pane: "tilePane",
          tileSize: 512,
          tileid: "mapbox/streets-v11",
          token:
            "pk.eyJ1IjoicmVjb241MTciLCJhIjoiY2l4cXBpbzZtMDAzNDMybDY2YnAzdjlndSJ9.MRq_ohDyD2x5t5DdlAwytA",
          zoomOffset: -1,
        },
        type: "xyz",
        url: "https://api.mapbox.com/styles/v1/{tileid}/tiles/{z}/{x}/{y}?access_token={token}",
      },
    },
    visible_default: false,
  },

  //   'l0_gray_basemap': {
  //   attribution: `&copy; ${link('CartoDB', 'https://carto.com/')}`,
  //   info: 'https://carto.com/',
  //   parts: {
  //     0: {
  //       options: {
  //         edgeBufferTiles: 1,
  //         pane: 'tilePane',
  //         tileSize: 512,
  //         tileid: 'cartodb/positron',
  //         zoomOffset: -1,
  //       },
  //       type: 'xyz',
  //       url: 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png',
  //     },
  //   },
  //   visible_default: true,
  // },
};
export default layers;
